import { render, staticRenderFns } from "./Ideas_bank_modal.vue?vue&type=template&id=340a9907"
import script from "./Ideas_bank_modal.vue?vue&type=script&lang=js"
export * from "./Ideas_bank_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports